import React, { memo } from "react";
import PropTypes from "prop-types";
import getDocStyle from "../../utils/getDocStyle";

const Circle = ({
  radius = 1,
  cx = 0,
  cy = 0,
  fill = getDocStyle("metabolon-base"),
  strokeWidth = 0,
  pointerEvents = "auto",
  handleEvents = undefined,
  opacity = undefined,
  name = null,
  value = null,
  depth = 1,
  comparison = null,
  detected = null,
  pathway_name = null,
  section = null,
  group = null,
}) => {
  return (
    <circle
      cx={cx}
      cy={cy}
      r={radius}
      stroke={getDocStyle("metabolon-base")}
      strokeWidth={strokeWidth}
      fill={fill}
      opacity={opacity}
      onMouseEnter={handleEvents}
      onMouseLeave={handleEvents}
      onClick={handleEvents}
      pointerEvents={pointerEvents}
      data-value={value}
      data-type={"metabolite"}
      data-source={"circlepack"}
      data-name={name}
      data-depth={depth}
      data-comparison={comparison}
      data-detected={detected}
      data-pathway_name={pathway_name}
      data-section={section}
      data-group={group}
    />
  );
};

Circle.propTypes = {
  radius: PropTypes.number,
  cx: PropTypes.number,
  cy: PropTypes.number,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
  pointerEvents: PropTypes.string,
  handleEvents: PropTypes.func,
  opacity: PropTypes.number,
  name: PropTypes.string,
  value: PropTypes.string,
  depth: PropTypes.number,
  comparison: PropTypes.string,
  detected: PropTypes.string,
  pathway_name: PropTypes.string,
  section: PropTypes.string,
  group: PropTypes.string,
};

export default memo(Circle);
